
/**
 * 트윗 유형
 */
export type GetTweetById200BasicInfoAllOfTwoTweetType = typeof GetTweetById200BasicInfoAllOfTwoTweetType[keyof typeof GetTweetById200BasicInfoAllOfTwoTweetType];


// eslint-disable-next-line @typescript-eslint/no-redeclare
export const GetTweetById200BasicInfoAllOfTwoTweetType = {
  ORIGINAL: 'ORIGINAL',
  REPLY: 'REPLY',
  QUOTE: 'QUOTE',
  RETWEET: 'RETWEET',
} as const;
